module.exports = __webpack_public_path__ + "img/share-screen.9a03b553.svg";